// Label for navigation items with external links

import React from 'react';
import { ExternalLink } from 'lucide-react';
import { cn } from '@/utilities/cn';

type NavItemLabelProps = {
  label: string;
  external?: boolean;
  className?: string;
  iconClassName?: string;
  iconStyle?: React.CSSProperties;
};

const splitLabelForTrailingIcon = (label: string) => {
  const trimmedLabel = label.trim();
  const lastSpaceIndex = trimmedLabel.lastIndexOf(' ');

  if (lastSpaceIndex === -1) {
    return { leadingText: '', trailingText: trimmedLabel };
  }

  return {
    leadingText: trimmedLabel.slice(0, lastSpaceIndex),
    trailingText: trimmedLabel.slice(lastSpaceIndex + 1),
  };
};

const NavItemLabel: React.FC<NavItemLabelProps> = ({
  label,
  external = false,
  className,
  iconClassName,
  iconStyle,
}) => {
  if (!external) {
    return <span className={className}>{label}</span>;
  }

  const { leadingText, trailingText } = splitLabelForTrailingIcon(label);

  return (
    <span className={cn('min-w-0', className)}>
      {leadingText ? `${leadingText} ` : null}
      <span className="inline-flex items-center gap-1 whitespace-nowrap">
        {trailingText}
        <ExternalLink
          className={cn(
            'size-[0.8em] shrink-0 opacity-80 transition-colors group-hover/nav-item:text-current',
            iconClassName
          )}
          style={iconStyle}
          aria-hidden="true"
        />
      </span>
    </span>
  );
};

export default NavItemLabel;
